import React from 'react';
import PropTypes from 'prop-types';
import { PsLinkLabel } from './ps-link-label/PsLinkLabel';
import { AuthContext } from '../../../shared/routing/AuthContext';
import RouterUtils from '../../../shared/routing/RouterUtils';
import { PsRoutes } from '../../../shared/routing/Routes';

export const CompanyLabel = (
    {
        company,
    },
) => {
    const { currentUser } = React.useContext(AuthContext);

    if ( !company ) {
        return null;
    }

    const companyName = company.name();
    const to = currentUser.canSeeOutsources()
        ? RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DETAIL, { id: company.id() })
        : undefined;

    return (
        <PsLinkLabel
            to={to}
            label={companyName}
        />
    );
};

CompanyLabel.propTypes = {
    company: PropTypes.object,
};

CompanyLabel.defaultProps = {
    company: null,
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/shared/components/CompanyLabel.jsx